import * as React from 'react';
export function useTimeout(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var timeoutIDRef = React.useRef();
  React.useEffect(function () {
    timeoutIDRef.current = window.setTimeout(callback, delay);
    return cancelTimer;
  }, [callback, delay]);
  return cancelTimer;

  function cancelTimer() {
    var timeoutID = timeoutIDRef.current;

    if (timeoutID) {
      timeoutIDRef.current = undefined;
      window.clearTimeout(timeoutID);
    }
  }
}